export function scrollManager (htmlClass) {
    const element = document.querySelector(htmlClass);
    if (element !== null) {
        window.addEventListener('scroll', function () {
            const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
            let opacity = window.scrollY / scrollableHeight;
            element.style.opacity = opacity > 1 ? 1 : opacity;
        });
    }
}